/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { DevDateTimeRange } from './DevDateTimeRange';
import {
    DevDateTimeRangeFromJSON,
    DevDateTimeRangeFromJSONTyped,
    DevDateTimeRangeToJSON,
    DevDateTimeRangeToJSONTyped,
} from './DevDateTimeRange';

/**
 * 
 * @export
 * @interface DevEventInboxFilter
 */
export interface DevEventInboxFilter {
    /**
     * 
     * @type {boolean}
     * @memberof DevEventInboxFilter
     */
    isProcessed?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevEventInboxFilter
     */
    topics?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevEventInboxFilter
     */
    types?: Array<string> | null;
    /**
     * 
     * @type {Array<DevDateTimeRange>}
     * @memberof DevEventInboxFilter
     */
    messageTime?: Array<DevDateTimeRange> | null;
}

/**
 * Check if a given object implements the DevEventInboxFilter interface.
 */
export function instanceOfDevEventInboxFilter(value: object): value is DevEventInboxFilter {
    return true;
}

export function DevEventInboxFilterFromJSON(json: any): DevEventInboxFilter {
    return DevEventInboxFilterFromJSONTyped(json, false);
}

export function DevEventInboxFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevEventInboxFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'isProcessed': json['isProcessed'] == null ? undefined : json['isProcessed'],
        'topics': json['topics'] == null ? undefined : json['topics'],
        'types': json['types'] == null ? undefined : json['types'],
        'messageTime': json['messageTime'] == null ? undefined : ((json['messageTime'] as Array<any>).map(DevDateTimeRangeFromJSON)),
    };
}

export function DevEventInboxFilterToJSON(json: any): DevEventInboxFilter {
    return DevEventInboxFilterToJSONTyped(json, false);
}

export function DevEventInboxFilterToJSONTyped(value?: DevEventInboxFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isProcessed': value['isProcessed'],
        'topics': value['topics'],
        'types': value['types'],
        'messageTime': value['messageTime'] == null ? undefined : ((value['messageTime'] as Array<any>).map(DevDateTimeRangeToJSON)),
    };
}

